import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import text from "../helper/text";

const Wrapper = styled.div`
  width: calc(100% - 50px);
  line-height: 15px;
  padding: 6px 25px 9px 25px;

  text-transform: uppercase;

  opacity: 0.8;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
  text-align: center;
  color: #3949ab;
  line-height: 15px;

  @media (min-width: 1400px) {
    width: 1350px;
    margin: 0 calc(50vw - 700px);
  }
  @media (max-width: 700px) {
    display: none;
  }
`;

class PageHead extends Component {
  render() {
    return (
      <Wrapper>{text.get(this.props.translations, "Sub_heading")}</Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageHead);



// WEBPACK FOOTER //
// ./src/components/PageHead.js